<template>
    <div>
        <el-dialog append-to-body :title="isControls == 1 ? '新增付款凭证' : isControls == 2 ? '编辑付款凭证' : '付款凭证详情'" :visible.sync="isDialog" width="1200px" :before-close="handleClose" :close-on-click-modal="false">
            <div v-if="isControls !== 3">
                <div>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">
                                    <span class="required">*</span>
                                    付款凭证类型 ：
                                </div>
                                <div>
                                    <el-select v-model="result.Receipt_Types" placeholder="请选择" class="el-select-max" @change="handleChange">
                                        <el-option v-for="item in ReceiptTypeopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>

                                    <span :class="loadingText.includes('识别成功') ? 'sucess-status-text' : 'required'" style="font-size: 12px" v-if="isControls == 1">{{ loadingText }}</span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="24" v-if="isControls == 1">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">
                                    <span class="required">*</span>
                                    附件：
                                </div>
                                <div>
                                    <Hwupload ref="Hwupload" status="receipt" @onSuccess="onSuccess" v-if="isDialog" />
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="24">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">
                                    <span class="required">*</span>
                                    汇入银行：
                                </div>
                                <div>
                                    <el-select v-model="result.Receipt_Bankstatus" placeholder="请选择" class="el-select-max" :disabled="result.Receipt_Types == 1 || result.Receipt_Types == 4 || result.Receipt_Types == 5">
                                        <el-option v-for="item in Banknameopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                                    </el-select>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="24">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">
                                    <span class="required">*</span>
                                    汇款单位：
                                </div>
                                <div>
                                    <el-input v-model="result.Receipt_Code" clearable class="el-select-max"></el-input>
                                    <span class="required" style="font-size: 12px" v-if="result.Receipt_Types == 1">请输入汇款单位+财务入账票号</span>
                                </div>
                            </div>
                        </el-col>

                        <el-col :span="24">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">
                                    <span class="required">*</span>
                                    付款日期：
                                </div>
                                <div><el-date-picker v-model="result.Receipt_PayDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" clearable></el-date-picker></div>
                            </div>
                        </el-col>
                        <el-col :span="24">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">
                                    <span class="required">*</span>
                                    汇款金额：
                                </div>
                                <div>
                                    <el-input v-model="result.Receipt_Amount" @input="handleInput($event, 'result', 'Receipt_Amount')" clearable class="el-select-max"></el-input>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="24" v-if="result.Receipt_Types !== 4 && result.Receipt_Types !== 5">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">
                                    <span class="required">*</span>
                                    汇出银行：
                                </div>
                                <div><el-input v-model="result.Receipt_SourceBank" clearable class="el-select-max"></el-input></div>
                            </div>
                        </el-col>
                        <el-col :span="24" v-if="isControls == 2">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">附件信息：</div>
                                <div class="operation-bar-block-a" @click="downFile(result.Payment_Receipt_File)" v-if="result.Payment_Receipt_File">{{ result.Payment_Receipt_File }}</div>
                                <div v-else>暂无相关附件信息</div>
                            </div>
                        </el-col>

                        <el-col :span="24" v-if="isControls == 2">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">重新上传附件：</div>
                                <div>
                                    <Hwupload ref="Hwupload" v-if="isDialog" />
                                </div>
                            </div>
                        </el-col>

                        <el-col :span="24" v-if="isControls == 2">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">收据分配信息：</div>
                                <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="ReceiptLogs" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" style="width: 1000px">
                                    <el-table-column prop="ERP订单号" label="ERP订单号" align="center"></el-table-column>
                                    <el-table-column prop="分配金额" label="分配金额" align="center">
                                        <template slot-scope="scope">￥{{ scope.row['分配金额'] }}</template>
                                    </el-table-column>
                                    <el-table-column prop="分配时间" label="分配时间" align="center"></el-table-column>
                                    <el-table-column prop="审核状态" label="审核状态" align="center">
                                        <template slot-scope="scope">
                                            <span :class="scope.row['审核状态'] == '已审核' ? 'sucess-status-text' : 'is-status-text'">{{ scope.row['审核状态'] }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                        <el-col :span="24" v-if="isControls == 2">
                            <div class="hw-form-item">
                                <div class="hw-form-item-label">处理日志：</div>
                                <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="Processinglog" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" style="width: 1000px">
                                    <el-table-column prop="Credit_Control_Orders_SN" label="序号" align="center" width="80">
                                        <template slot-scope="scope">
                                            {{ scope.$index + 1 }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Log_AddTime" label="时间" align="center">
                                        <template slot-scope="scope">
                                            {{ scope.row.Log_AddTime | formatDates }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="Log_User" label="操作人" align="center"></el-table-column>
                                    <el-table-column prop="Log_Remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
                                </el-table>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <div v-else>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款凭证类型 ：</div>
                            <div>{{ result.Receipt_Type }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇入银行：</div>
                            <div>{{ result.Receipt_BankName }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇款单位：</div>
                            <div>{{ result.Receipt_Code }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">付款日期：</div>
                            <div>{{ result.Receipt_PayDate }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇款金额：</div>
                            <div>{{ result.Receipt_Amount }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24" v-if="result.Receipt_Types !== 4 && result.Receipt_Types !== 5">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">汇出银行：</div>
                            <div>{{ result.Receipt_SourceBank }}</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">附件信息：</div>
                            <div class="operation-bar-block-a" @click="downFile(result.Payment_Receipt_File)" v-if="result.Payment_Receipt_File">{{ result.Payment_Receipt_File }}</div>
                            <div v-else>暂无相关附件信息</div>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">收据分配信息：</div>
                            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="ReceiptLogs" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" style="width: 1000px">
                                <el-table-column prop="ERP订单号" label="ERP订单号" align="center"></el-table-column>
                                <el-table-column prop="分配金额" label="分配金额" align="center">
                                    <template slot-scope="scope">￥{{ scope.row['分配金额'] }}</template>
                                </el-table-column>
                                <el-table-column prop="分配时间" label="分配时间" align="center"></el-table-column>
                                <el-table-column prop="审核状态" label="审核状态" align="center">
                                    <template slot-scope="scope">
                                        <span :class="scope.row['审核状态'] == '已审核' ? 'sucess-status-text' : 'is-status-text'">{{ scope.row['审核状态'] }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                    <el-col :span="24">
                        <div class="hw-form-item">
                            <div class="hw-form-item-label">处理日志：</div>
                            <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="Processinglog" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" style="width: 1000px">
                                <el-table-column prop="Credit_Control_Orders_SN" label="序号" align="center" width="80">
                                    <template slot-scope="scope">
                                        {{ scope.$index + 1 }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Log_AddTime" label="时间" align="center">
                                    <template slot-scope="scope">
                                        {{ scope.row.Log_AddTime | formatDates }}
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Log_User" label="操作人" align="center"></el-table-column>
                                <el-table-column prop="Log_Remark" label="备注" align="center" show-overflow-tooltip></el-table-column>
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </div>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-if="isControls !== 3">
                <el-button @click="handleClose()">取消</el-button>
                <el-button @click="onSubmit()" type="primary">保存</el-button>
            </span>
            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-else>
                <el-button @click="handleClose()">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog
            title="已存在以下凭证，是否继续增加?"
            :visible.sync="historyAttachmentShow"
            width="1200px"
            :before-close="() => { historyAttachmentShow = false; }">
            <div>
                <el-table  :row-class-name="tableRowClassName" @row-click="handleRowClick" :data="historyAttachmentList" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                    <el-table-column label="序号" align="center" width="60">
                        <template v-slot="scope">
                            {{ scope.$index + 1 }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="Receipt_BankName" label="汇入银行" align="center" />
                    <el-table-column prop="Receipt_Code" label="汇款单位" align="center" />
                    <el-table-column prop="Receipt_PayDate" label="付款日期" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.Receipt_PayDate | formatDate }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="Receipt_Amount" label="汇款金额" align="center">
                        <template v-slot="scope">￥{{ scope.row.Receipt_Amount }}</template>
                    </el-table-column>
                    <el-table-column prop="Payment_Receipt_File" label="附件" align="center">
                        <template v-slot="scope">
                            <div v-if="scope.row.Payment_Receipt_File">
                                <el-image v-if="isImageFile(scope.row.Payment_Receipt_File)" style="width: 60px; height: 60px" :src="getFullImageUrl(scope.row.Payment_Receipt_File)" :preview-src-list="[getFullImageUrl(scope.row.Payment_Receipt_File)]" fit="cover" />
                                <span v-else @click="downFile(scope.row.Payment_Receipt_File)" style="cursor: pointer; color: #409eff">点击下载</span>
                            </div>
                            <span v-else>无</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="historyAttachmentShow = false">取消</el-button>
                <el-button type="primary" @click="handleConfirmAddReceipt">确认</el-button>
            </span>
        </el-dialog>
    </div>
  </template>

<script>
import Hwupload from '@/components/Hwupload/index.vue';
import { myMixin } from '@/utils/mixin.js';
import { cloneDeep, debounce } from 'lodash';
import { toLowerCaseKeys } from '@/utils/utils.js';

export default {
    name: 'PaymentVoucherDialog',
    mixins: [myMixin],
    components: { Hwupload },
    data() {
        return {
            isDialog: false,
            // eslint-disable-next-line no-useless-escape
            loadingText: '针对转账、银行承兑汇票类型支持AI智能识别,文件支持bmpjpggifpngpdf格式',
            isControls: 1, // 1新增 2编辑 3查看
            result: {},
            ReceiptLogs: [],
            ReceiptTypeopt: [],
            Processinglog: [],
            Banknameopt: [],
            historyAttachmentShow: false,
            historyAttachmentList: [],
            pendingReceiptData: null
        };
    },
    methods: {
        open(type, el) {
            this.handleOpen(type, el);
        },
        handleInput(evt, objKey, fieldKey) {
            // 保留两位小数、去除非法字符
            const raw = String(evt || '').replace(/[^\d.]/g, '');
            const normalized = raw.replace(/^(\d*\.\d{0,2}).*$/, '$1');
            this[objKey][fieldKey] = normalized;
        },
        handleOpen: async function (type, el) {
            this.isControls = type;
            this.result = {
                Last_Amount: '',
                Payment_Receipt_File: '',
                Payment_Receipt_Source: '',
                Payment_Receipt_Status: '',
                Payment_Receipt_User: '',
                Receipt_Addtime: '',
                Receipt_Amount: '',
                Receipt_BankName: '',
                Receipt_Code: '',
                Receipt_ID: '',
                Receipt_PayDate: '',
                Receipt_SourceBank: '',
                Receipt_Type: '',
                Receipt_Bankstatus: '',
                Receipt_Types: 0
            };
            this.loadingText = '针对转账、银行承兑汇票类型支持AI智能识别,文件支持bmp,jpg,gif,png,pdf格式';
            this.isDialog = true;
            if (this.isControls == 1) {
                try {
                    const [res1, res2] = await Promise.all([this.$newsApi.common.getBankname(), this.$newsApi.common.getReceiptType()]);
                    if (res1.data.Resultcode === 0) {
                        this.Banknameopt = Object.entries(res1.data.data).map(([key, value]) => ({ value: Number(key), label: value }));
                    }
                    if (res2.data.Resultcode === 0) {
                        this.ReceiptTypeopt = Object.entries(res2.data.data).map(([key, value]) => ({ value: Number(key), label: value }));
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.error('获取订单收据信息时出错:', error);
                }
            } else {
                this.getOrdersPaymentReceiptByID(el.Receipt_ID);
            }
        },
        handleClose() {
            this.isDialog = false;
            this.$emit('closed');
        },
        handleChange(e) {
            if (e == 1) {
                this.result.Receipt_Bankstatus = 4;
            }
            if (e == 4) {
                this.result.Receipt_Bankstatus = 5;
            }
            if (e == 5) {
                this.result.Receipt_Bankstatus = 6;
            }
        },
        async getOrdersPaymentReceiptByID(id) {
            try {
                const [res1, res2, res, res3, res4] = await Promise.all([
                    this.$newsApi.common.getBankname(),
                    this.$newsApi.common.getReceiptType(),
                    this.$newsApi.getOrdersPaymentReceiptByID({ Receipt_ID: id, action: 'edit' }),
                    this.$newsApi.getOrdersPaymentReceiptsDistributeList({ Receipt_ID: id }),
                    this.$newsApi.getMKLogsByTargetID({ Target_ID: id, Target_Type: 1 })
                ]);
                if (res.data.Resultcode === 0) {
                    this.result = { ...res.data.data, Receipt_Bankstatus: 0, Receipt_Types: 0 };
                }
                if (res1.data.Resultcode === 0) {
                    this.Banknameopt = Object.entries(res1.data.data).map(([key, value]) => {
                        if (value === this.result.Receipt_BankName) {
                            this.result.Receipt_Bankstatus = Number(key);
                        }
                        return { value: Number(key), label: value };
                    });
                }
                if (res2.data.Resultcode === 0) {
                    this.ReceiptTypeopt = Object.entries(res2.data.data).map(([key, value]) => {
                        if (value === this.result.Receipt_Type) {
                            this.result.Receipt_Types = Number(key);
                        }
                        return { value: Number(key), label: value };
                    });
                }
                if (res3.data.Resultcode === 0) {
                    this.ReceiptLogs = res3.data.data;
                }
                if (res4.data.Resultcode === 0) {
                    this.Processinglog = res4.data.data;
                }
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error('获取订单收据信息时出错:', error);
            }
        },
        onSuccess(e) {
            if (this.result.Receipt_Types == 0 || this.result.Receipt_Types == 1) {
                this.getOCRQuery(e);
            } else {
                this.loadingText = '针对转账、银行承兑汇票类型支持AI智能识别,文件支持bmp,jpg,gif,pdf格式';
            }
        },
        getOCRQuery(filepath) {
            this.loadingText = 'AI智能识别中...';
            this.$newsApi.getOCRQuery({ json: JSON.stringify({ filepath }) }).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.loadingText = 'AI识别成功';
                    let { Receipt_Amount, Receipt_BankName_Select, Receipt_Code, Receipt_PayDate, Receipt_SourceBank } = res.data.data;
                    this.result = {
                        ...this.result,
                        Receipt_Amount,
                        Receipt_PayDate,
                        Receipt_Code,
                        Receipt_SourceBank,
                        Receipt_BankName: Receipt_BankName_Select
                    };
                    if(this.result.Receipt_Types != 1)
                    {
                        const bank = this.Banknameopt.find((item) => item.label === Receipt_BankName_Select);
                        this.result.Receipt_Bankstatus = bank ? bank.value : '';
                    }
                    
                } else {
                    this.result = {
                        ...this.result,
                        Receipt_Amount: '',
                        Receipt_PayDate: '',
                        Receipt_Code: '',
                        Receipt_SourceBank: '',
                        Receipt_BankName: ''
                    };
                    this.result.Receipt_Bankstatus = '';
                    this.loadingText = res.data.Resultinfo || '识别失败';
                }
            });
        },
        getAddOrdersPaymentReceipt(json) {
            this.$newsApi.getAddOrdersPaymentReceipt(json).then((res) => {
                if (res.data.Resultcode == 0) {
                    this.$message({
                        message: '添加成功',
                        type: 'success',
                        duration: 2000,
                        onClose: () => {
                            this.handleClose();
                            this.$emit('success');
                        }
                    });
                }
            });
        },
        onSubmit: debounce(function () {
            let result = cloneDeep(this.result);
            result.Payment_Receipt_File = this.$refs.Hwupload && this.$refs.Hwupload.filePath;
            result.action = this.isControls == 1 ? 'receiptadd' : 'receiptedit';
            const receiptType = this.ReceiptTypeopt.find((item) => item.value == this.result.Receipt_Types);
            if (receiptType) {
                result.Receipt_Type = receiptType.label;
            }
            const bankName = this.Banknameopt.find((item) => item.value == this.result.Receipt_Bankstatus);
            if (bankName) {
                result.Receipt_BankName = bankName.label;
            }
            if (this.isControls == 1) {
                this.$newsApi.getCheckOrdersPaymentReceipt({ json: JSON.stringify(result) }).then((res) => {
                    if (res.data.Resultcode == 0) {
                        if (res.data.Resultinfo == 'true') {
                            this.getAddOrdersPaymentReceipt({ json: JSON.stringify(result) });
                        }
                        if (res.data.data) {
                            this.historyAttachmentList = res.data.data;
                            this.historyAttachmentShow = true;
                            this.pendingReceiptData = result;
                        }
                    }
                });
            } else {
                this.$newsApi.getEditOrdersPaymentReceipt({ json: JSON.stringify(result) }).then((res) => {
                    if (res.data.Resultcode == 0) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 2000,
                            onClose: () => {
                                this.handleClose();
                                this.$emit('success');
                            }
                        });
                    }
                });
            }
        }, 800),
        handleConfirmAddReceipt() {
            this.historyAttachmentShow = false;
            if (this.pendingReceiptData) {
                this.getAddOrdersPaymentReceipt({ json: JSON.stringify(this.pendingReceiptData) });
                this.pendingReceiptData = null;
            }
        },
        isImageFile(filename) {
            const imageExtensions = ['.bmp', '.jpg', '.gif', '.png', '.pd'];
            const ext = filename.slice(filename.lastIndexOf('.')).toLowerCase();
            return imageExtensions.includes(ext);
        },
        getFullImageUrl(path) {
            if (!path) return '';
            if (/^https?:\/\//.test(path)) return path;
            return this.$openFileUrl + path;
        },
        downFile(fileUrl) {
            window.open(this.$openFileUrl + fileUrl, '_blank');
        }
    }
};
</script>

<style scoped lang="scss">
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 140px;
    }
}
</style>


